<template>
  <div>
    <div v-if="subAreasOptions.length > 0">
      <div
        class="container-fluid"
        :class="{
          'my-2': !ReadOnly
        }"
      >
        <div class="row">
          <div class="col-12">
            <MultiSelectionPicker
              v-if="!ReadOnly"
              :all-items="subAreasOptions"
              :isbgwhite="true"
              :enable-bg-alternate="true"
              item-type-name="Subareas"
              :selected-items="currentSelection"
              :disabled="ReadOnly"
            />
          </div>
        </div>
        <div v-if="!ReadOnly" class="row mt-3">
          <div class="col-12">
            <Error
              is-alert-mode
              message="Puede seleccionar una(1) o más sub áreas. Selección múltiple."
            />
          </div>
        </div>
        <div v-if="!ReadOnly" class="row">
          <div class="col-12">
            <Error
              v-if="hasInnerError"
              message="Favor de seleccionar las subareas."
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <CustomChipsGroup
              title="Sub áreas seleccionadas"
              :selected-items="currentSelection"
              object-text="name"
              :disabled="ReadOnly"
              :class="{ 'custom-chips-group': ReadOnly }"
              @itemMarkedForDeletion="removeSelectionSubAreas"
            />
            <div v-if="showDeleteAlert && !ReadOnly" class="row mt-3">
              <div class="col-12">
                <Error
                  is-alert-mode
                  variant="info"
                  message="Las sub-áreas no pueden ser eliminadas si están atadas a una Meta."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!ReadOnly"
        class="mt-3 d-flex justify-content-end align-items-center"
      >
        <ActionButton i="fas fa-save" variant="success m-2" @click="save">
          Guardar
        </ActionButton>
      </div>
    </div>
    <div v-else class="row mt-3">
      <div class="col-12">
        <Error
          is-alert-mode
          message="Esta Área no requiere documentación de Sub Áreas."
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/common/ActionButton";
import MultiSelectionPicker from "@/components/common/MultiSelectionPicker";
import CustomChipsGroup from "@/components/common/CustomChipsGroup";
import Error from "@/components/common/Error";
import alert from "@/mixin/alert.mixin";
import PeiApi from "./service";
import { modulesName } from "@/modules";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations, mapState } = createNamespacedHelpers(
  modulesName.programServiceModuleName
);

export default {
  name: "SubAreasSelection",
  mixins: [alert],
  props: {
    programServiceAreaId: {
      type: [String, Number],
      required: true
    },
    areaId: {
      default: 0
    },
    hasError: {
      type: Boolean,
      default: false
    },
    ReadOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActionButton,
    MultiSelectionPicker,
    CustomChipsGroup,
    Error
  },
  data() {
    return {
      currentSelection: [],
      isSubmitted: false
    };
  },
  computed: {
    ...mapState(["createdGoals"]),
    ...mapGetters(["resource", "subAreasOptions", "selectedSubAreas"]),
    showDeleteAlert() {
      return this.currentSelection.some(x => x.disabled);
    },
    hasInnerError() {
      return (
        (this.hasError && !this.currentSelection.length) ||
        (this.isSubmitted && this.currentSelection.length <= 0)
      );
    }
  },
  methods: {
    ...mapMutations(["setSubAreaSelection"]),
    async save() {
      this.isSubmitted = true;
      if (this.currentSelection.length <= 0) return false;

      let data = this.currentSelection.map(e => ({
        ProgramServiceAreaId: parseInt(this.programServiceAreaId),
        subAreaId: e.id
      }));

      try {
        await PeiApi.SaveSubAreas(data);

        this.ShowToast(
          this.resource("R03200110"),
          this.resource("R03200109"),
          "success"
        );
        this.setSubAreaSelection(this.currentSelection);
        this.$emit('pending-changes', false);

        return true;
      } catch (error) {
        this.ShowToast(err, this.resource("R03200108"), "error");
        return false;
      }
    },
    removeSelectionSubAreas(item) {
      let editedItemIndex = this.currentSelection.findIndex(
        e => e.id === item.id
      );
      this.currentSelection.splice(editedItemIndex, 1);
    },
    setSubAreasDisableValue(selectedSubAreas, createdGoals) {
      const usedSubAreaIds = createdGoals.map(x => x.subAreaId);
      this.currentSelection = selectedSubAreas.map(x => ({
        ...x,
        disabled: usedSubAreaIds.includes(x.id)
      }));
    }
  },
  watch: {
    createdGoals: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.setSubAreasDisableValue(this.selectedSubAreas, newValue);
      }
    },
    selectedSubAreas: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.setSubAreasDisableValue(newValue, this.createdGoals);
      }
    },
    currentSelection: {
      deep: true,
      immediate: false,
      handler(newValue) {
        if (this.selectedSubAreas.length != newValue.length) {
          this.$emit('pending-changes', true);
        }
      }
    },
  }
};
</script>
<style scoped lang="scss">
.actions {
  display: flex;
  justify-content: flex-end;
}

::v-deep .custom-chips-group {
  & div.mt-3 {
    margin-top: 0% !important;
  }
  & .chips-container {
    margin-top: 0% !important;
    padding-top: 0% !important;
  }
}
</style>
